import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Phone = forwardRef<SVGSVGElement, SvgIconProps>(
  function Phone(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M15.73 16.81c.3-.37 1.35-2.1 2.93-1.57 1.65.52 5.78 1.95 3.83 4.5C15.96 28.6-3.54 9.01 5.23 2.5 7.78.6 9.21 4.65 9.73 6.3c.53 1.65-1.12 2.63-1.57 2.93-1.13 1.05 6.6 8.7 7.58 7.58z" />
      </SvgIcon>
    )
  },
)

export default Phone
